import React from 'react';
import styles from '../styles/related-entities-widget.module.scss';
import classNames from "classnames";
import {RelatedEntitiesWidgetContentItem} from "./related-entities-widget.content.item";
import type {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";
import {observer} from "mobx-react";

export const RelatedEntitiesWidgetContent = observer(({controller}) => {
  const {state} = controller;
  const {entities} = state;

  return (
    <div className={classNames(styles.entities_container)}>
      {
        entities?.map((entity: EntityViewModel) =>
          <RelatedEntitiesWidgetContentItem item={entity} controller={controller} key={entity.id}/>)
      }
    </div>
  )
})